<template>
    <fieldset class="flex w-full flex-wrap">
        <fancy-select
            :vid="this.name + '.purpose'"
            :name="this.name + '.purpose'"
            :test="this.test"
            label="What will you use this money for?"
            v-model="purpose"
            :options="defaultOptions"
            :rules="{ required: true , in: Object.keys(defaultOptions) }"
            @input="update"
            :custom-messages="customMessages"
            tooltip='Please choose the option closest to your circumstances or, if none, choose "Something else".'
            class="mb-8"
        ></fancy-select>
    </fieldset>
</template>

<script>
import FancySelect from "./../../components/form/fancyselect";
import DigiSelect from "./../../components/form/digi-select";
import { isString, extend } from "underscore";
import ExpandTransition from './../../components/expand-transition';

export default {
    methods: {
        update() {
            this.$emit('input', this.purpose);
        }
    },
    props: {
        name: String,
        value: String,
        defaultOptions: Object,
        test: {
            default: false,
        }
    },
    data() {
        return {
            purpose: null,
            customMessages: {
                'required': 'Please tell us what you will use this money for',
                'required_if': 'Please tell us what you will use this money for',
                'in': 'Please tell us what you will use this money for',
            }
        };
    },
    components: {
        "digi-select": DigiSelect,
        "fancy-select": FancySelect,
        'expand-transition': ExpandTransition
    }
}
</script>

<style lang="stylus" scoped>

</style>